import { format } from 'date-fns';
import React from 'react';

import { Periodicity } from '../time-period-selector/PeriodsTypes';

import * as styles from './DataLastUpdated.module.scss';

/* eslint-disable-next-line */
export interface FilteredPeriodProps {
  selectedPeriod: string;
  comparisonPeriod: string;
  selectedPeriodicity: Periodicity;
}

const DataLastUpdated: React.FC<{ date: number }> = ({ date }) => {
  const lastUpdatedText = formatLastUpdatedDate(date);

  return date ? (
    <div className="inline-flex text-lighter text-sm font-normal">
      <span data-test-id="data-last-updated" className={styles.LastUpdated__Item}>
        Updated on {lastUpdatedText}.
      </span>
    </div>
  ) : null;
};

const formatLastUpdatedDate = (lastUpdatedDate: number): string => {
  const date = new Date(lastUpdatedDate);
  return format(date, 'dd MMM yyyy');
};

export default DataLastUpdated;
